import { render, staticRenderFns } from "./index.vue?vue&type=template&id=22b81592&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=22b81592&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b81592",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b81592')) {
      api.createRecord('22b81592', component.options)
    } else {
      api.reload('22b81592', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=22b81592&scoped=true", function () {
      api.rerender('22b81592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BrandSettings/DeliveryTimeslots/index.vue"
export default component.exports